import './Explore.css';
import NavBar from '../../components/NavBar/NavBar';
import ExploreLeftSection from '../../components/ExploreLeftSection/ExploreLeftSection';
import ExploreRightSection from '../../components/ExploreRightSection/ExploreRightSection';
import Footer from '../../components/Footer/Footer';

const Explore = () => {

    

    return(
        <>
            <NavBar/>
            <div className="explore-productexplore-wrapper">
                <ExploreLeftSection/>
                <ExploreRightSection/>
            </div>
            <Footer/>
        </>
    )   
};

export default Explore;